"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import floorPlanTab from "../../../../public/images/floor-plans/grundriss-grau.png";

const Hero = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("floorPlanDesigns.hero");

  return (
    <HeroSection
      image={floorPlanTab}
      alt={"Grundriss Design Beispiel"}
      tab={tC("floorPlanDesigns")}
      title={tH("title")}
      text={tH("text")}
      linkTitle={tH("linkTitle")}
      href={"/user/order-sales-optimized-floor-plan"}
    />
  );
};

export default Hero;
